import { render } from "./TimeDashboard.vue?vue&type=template&id=0cb67b8c"
import script from "./TimeDashboard.vue?vue&type=script&lang=js"
export * from "./TimeDashboard.vue?vue&type=script&lang=js"

import "./TimeDashboard.vue?vue&type=style&index=0&id=0cb67b8c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__